// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1r99M","box":"WorkspacesBox_box__29kbJ","node":"WorkspacesBox_node__1FYib"};